"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Portal;

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Portal(_ref) {
  var children = _ref.children,
      _ref$documentId = _ref.documentId,
      documentId = _ref$documentId === void 0 ? 'root' : _ref$documentId;
  return /*#__PURE__*/_reactDom.default.createPortal( /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children), document.getElementById(documentId));
}

Portal.propTypes = {
  children: _propTypes.default.node,
  documentId: _propTypes.default.string
};